import React from "react";

import styles from "./styles.m.css";
import GoogleSearch from "../../rows/header/google-search";

const GoogleSearchPage = () => {
  return (
    <React.Fragment>
      <div className="container">
        <div className={`${styles["google-search"]}`}>
          <GoogleSearch />
        </div>
      </div>
    </React.Fragment>
  );
};

export { GoogleSearchPage };
